import React, { Component } from 'react';

class ConsoleTextAnimation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true,
      letterIndex: props.text ? props.text.length : 0, // Set initial letterIndex based on text length
      colors: props.colors || ['black'],
      text: props.text || "Hello. I am a programmer, husband and a cat dad 🐈🐈‍⬛. I work as a Senior Data Engineer at Data Sciences. I am passionate about algorithmic trading, cryptocurrencies, finance, cloud solutions and web applications. I am from Istanbul 🇹🇷 and I live in Montréal 🇨🇦.",
      colorIndex: 0,
    };
    this.animationInterval = null;
    this.underscoreInterval = null;
  }

  async componentDidMount() {
		const animationStarted = await Boolean(sessionStorage.getItem('animationStarted'));
		if (animationStarted) {
			console.log('already ran', animationStarted)
		} else {
			this.startAnimation();
			console.log('starting', animationStarted)
		}
  }

	startAnimation = () => {
		this.animationInterval = setInterval(() => {
			const { text } = this.state;
			const textLength = text.length;
			const { letterIndex, colorIndex, colors } = this.state;
			const nextLetterIndex = letterIndex + 1;
	
			if (nextLetterIndex <= textLength) {
				this.setState({ letterIndex: nextLetterIndex });
			} else if (colorIndex < colors.length - 1) {
				this.setState({
					letterIndex: 0,
					colorIndex: colorIndex + 1,
				});
			} else {
				clearInterval(this.animationInterval); // Animation completed, clear the interval
				this.setAnimationStarted(); // Set animationStarted to true
			}
		},10); // Adjust the interval duration as needed
	};
	
	setAnimationStarted = () => {
		sessionStorage.setItem('animationStarted', 'true');
	};

  animateUnderscore = () => {
    this.underscoreInterval = setInterval(() => {
      this.setState((prevState) => ({
        visible: !prevState.visible,
      }));
    }, 400);
  }

	render() {
		const { visible, text, colors, colorIndex, letterIndex } = this.state;
		
		const animationStarted = sessionStorage.getItem('animationStarted');
		// Conditionally determine the substring length based on animationStarted
		const substringLength = animationStarted ? text.length : letterIndex;
	
		return (
			<div className="console-container">
				<span id="text" style={{ color: colors[colorIndex] }}>
					{text.substring(0, substringLength)}
				</span>
				<span className={`console-underscore ${visible ? '' : 'hidden'}`}>_</span>
			</div>
		);
	}
	
	
}

export default ConsoleTextAnimation;
